export enum EInvoiceType {
  PARTIAL_INVOICE = 'PARTIAL_INVOICE',
  COMMERCIAL_INVOICE = 'COMMERCIAL_INVOICE',
  CREDIT_NOTE = 'CREDIT_NOTE',
  CORRECTED_INVOICE = 'CORRECTED_INVOICE',
  SELF_BILLED_INVOICE = 'SELF_BILLED_INVOICE',
  PARTIAL_CONSTRUCTION_INVOICE = 'PARTIAL_CONSTRUCTION_INVOICE',
  PARTIAL_FINAL_CONSTRUCTION_INVOICE = 'PARTIAL_FINAL_CONSTRUCTION_INVOICE',
  FINAL_CONSTRUCTION_INVOICE = 'FINAL_CONSTRUCTION_INVOICE',
}
